module.exports = ":host {\n  display: block;\n  margin-top: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/list/list.style.scss
// module id = 757
// module chunks = 2